import router from '@/router'
import axios from 'axios'
// process.env.NODE_ENVによって接続先を変更
if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = 'https://tokusawaen.xsrv.jp/wp/wp-json/tmr/v1'
} else {
  axios.defaults.baseURL = 'http://tmerp.local/wp-json/tmr/v1'
}
// axios.defaults.baseURL = 'https://tokusawaen.xsrv.jp/wp/wp-json/tmr/v1'
/*
// 予約データ
data: {
  cat: 'ブラキャン',
  date: [
    { from: '2025-03-27', to: '2025-03-28' }
  ],
  tent: 1,
  user: [
    { adult: 2, child: 2 },
    { adult: 1, child: 3 }
  ],
  feeKubun: '',
  dinner: '信州サーモンとキノコのアヒージョ',
  allergy: '',
  memo: '',
  name: '',
  kana: '',
  email: '',
  tel: '',
  zip: '',
  address: ''
}
*/

const state = {
  step: 0,
  data: {},
  dates: [],
  availableTentNumMax: 0
}
const getters = {
  step: (state) => state.step,
  data: (state) => state.data,
  dates: (state) => state.dates,
  availableTentNumMax: (state) => state.availableTentNumMax
}

const mutations = {
  step (state, step) {
    state.step = step
  },
  data (state, data) {
    state.data = data
  },
  dates (state, dates) {
    state.dates = dates
  },
  availableTentNumMax (state, availableTentNumMax) {
    state.availableTentNumMax = availableTentNumMax
  }
}
const actions = {
  //
  // 予約追加
  async add ({ commit, dispatch }) {
    commit('processing', true, { root: true })
    // 予約を送信してサーバーに保存する
    return new Promise((resolve) => {
      axios
        .post('/user/yoyaku/', state.data)
        .then((response) => {
          resolve(response.data)
          dispatch('init')
          router.push({ name: 'thanks' })
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          commit('processing', false, { root: true })
        })
    })
    // // Thanksページに遷移
    // dispatch('init')
  },
  //
  // 予約追加
  async addRentaltent ({ commit, dispatch }, data) {
    commit('processing', true, { root: true })
    // 予約を送信してサーバーに保存する
    return new Promise((resolve) => {
      axios
        .post('/user/yoyaku/rentaltent', data)
        .then((response) => {
          console.log(response.data)
          dispatch('init')
          router.push({ name: 'thanks' })
          resolve(response.data)
        })
        .catch((error) => {
          console.log(error)
          alert('エラー：' + error.response.data)
        })
        .finally(() => {
          commit('processing', false, { root: true })
        })
    })
  },
  //
  // 予約データ初期化
  init ({ commit }) {
    commit('step', 0)
    commit('data', {})
  },
  //
  // 日付範囲で利用可能なテント数を取得
  async getBracanAvailableTent ({ commit }, range) {
    return new Promise((resolve) => {
      axios
        .post('/bracan/tent/', range)
        .then((response) => {
          console.log(response.data)
          commit('availableTentNumMax', response.data)
          resolve(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    })
  }
}

const Yoyaku = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default Yoyaku
